import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/methodology/methodology-client.tsx");
